import { flushSync } from "react-dom";

export function viewTransition(callback: () => void) {
  if (!document.startViewTransition) {
    callback();
    return;
  }
  document.startViewTransition(() => {
    flushSync(() => {
      callback();
    });
  });
}
